var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFloorNumIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.605,
    height: 12.427,
    viewBox: "0 0 14.605 12.427",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1267",
    "data-name": "Group 1267",
    transform: "translate(0.375 0.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15724",
    "data-name": "Path 15724",
    d: "M-1410.492,1497.083h-8.258v11.677h2.549",
    transform: "translate(1418.75 -1497.083)",
    fill: "none",
    stroke: "#29a19c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15725",
    "data-name": "Path 15725",
    d: "M-1418.75,1506.333h4.517",
    transform: "translate(1418.75 -1503.367)",
    fill: "none",
    stroke: "#29a19c",
    strokeLinecap: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15726",
    "data-name": "Path 15726",
    d: "M-1400.812,1507.5h6.262v8.618h-8.7",
    transform: "translate(1408.404 -1504.469)",
    fill: "none",
    stroke: "#29a19c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15727",
    "data-name": "Path 15727",
    d: "M-1393.917,1521.124V1515",
    transform: "translate(1402.174 -1509.474)",
    fill: "none",
    stroke: "#29a19c",
    strokeLinecap: "round",
    strokeWidth: 0.75
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloorNumIcon);
export default __webpack_public_path__ + "static/media/FloorNumIcon.4975f9fa56cda9f12391b51a22313c25.svg";
export { ForwardRef as ReactComponent };